import { defineComponent as _defineComponent } from 'vue'
import { Device } from '@/models/device';
import ClickMenu from '@/components/menu/ClickMenu.vue';
import { MachineType } from '@/models/enums/MachineType';
import { devicesService } from '@/services/devices.service';
import { computed } from 'vue';
import { useI18n } from '@/composables/i18n';
import { isEmpty, isNil } from '@/utils/misc';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'EquipmentFilter',
  props: {
    type: null,
    value: { default: () => [] },
    position: { default: 'is-bottom-left' },
    single: { type: Boolean, default: false }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ((e: 'input', value: string[]) => void), expose: any, slots: any, attrs: any }) {

const props = __props as { type: MachineType, value: string | string[], position: string, single: boolean };





const { t } = useI18n();

function emitValue(event: string | number | (string | number)[]) {
  emit('input', event as string[]);
}

const icon = computed<string>(() => {
  switch (props.type) {
    case MachineType.Cut:
      return 'cutting';
    case MachineType.Bend:
      return 'bending';
    case MachineType.Tube:
      return 'tube';
    default:
      return 'cutting';
  }
});

const deviceIds = computed<string[]>(() =>
  devices.value.map((device) => device.deviceId),
);

const deviceNames = computed<string[]>(() =>
  devices.value.map((device) => device.name),
);

const devices = computed<Device[]>(() =>
  devicesService.store
    .getAll()
    .filter((device) => device.getType() === props.type),
);

const formattedValue = computed<string>(() => {
  if (props.single) {
    return devices.value.find((x) => x.deviceId === props.value)?.name ?? '';
  }

  if (isEmpty(props.value)) {
    return `${devices.value.length}`;
  }

  return `${props.value.length}`;
});

const showValue = computed<boolean>(() => !isNil(props.value));

return { __sfc: true,props, emit, t, emitValue, icon, deviceIds, deviceNames, devices, formattedValue, showValue, ClickMenu }
}

})